import React from 'react'
import PropTypes from 'prop-types'

const Flex = React.forwardRef(({
  children,
  className = '',
  alignItems,
  justifyContent,
  mobileFlex = true,
  flexDirection = 'row',
  flexWrap,
}, ref) => {
  const getFlexResponsive = () => (mobileFlex ? 'd-flex' : 'd-md-flex')
  return (
    <div
      ref={ref}
      className={`${getFlexResponsive()} ${className} ${
        flexDirection ? 'flex-' + flexDirection : ''
      } ${alignItems ? 'align-items-' + alignItems : ''} ${
        justifyContent ? 'justify-content-' + justifyContent : ''
      } ${flexWrap ? 'flex-' + flexWrap : ''}`}
    >
      {children}
    </div>
  )
})

Flex.displayName = 'Flex'

Flex.propTypes = {
  className: PropTypes.string,
  alignItems: PropTypes.string,
  flexDirection: PropTypes.string,
  justifyContent: PropTypes.string,
  mobileFlex: PropTypes.bool,
  flexWrap: PropTypes.string,
}

export default Flex
